import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

export const guestOnlyGuard: CanActivateFn = async (route, state) => {
  const router: Router = inject(Router);
  const authService = inject(AuthenticationService);

  // Only make API call if not cached - this prevents duplicate calls
  const isLoggedIn = await authService.isLoggedIn();

  if (isLoggedIn) {
    // Redirect to dashboard if user is authenticated
    return router.navigate(['/dashboard']);
  }

  // Allow access to login page if user is not logged in
  return true;
};
